/* eslint-disable max-len,react/jsx-tag-spacing */

import React from "react";
import { BRAND_COLOR } from "components/constants";

import css from "./styles.module.scss";

type Props = {
  type: string;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
};

const Icon: React.FC<Props> = ({
  type,
  className = "",
  width = undefined,
  height = undefined,
  color = "",
  ...iconProps
}: React.ComponentProps<typeof Icon>) => {
  let icon;
  const svgProps = {
    width,
    height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: css.svg,
  };

  switch (type) {
    case "chevron-icon":
      icon = (
        <svg {...svgProps}>
          <path
            data-name="Icon awesome-chevron-down"
            d="M8.303 10.634L.29 2.623a.989.989 0 010-1.4l.934-.934a.989.989 0 011.4 0l6.379 6.348L15.382.288a.989.989 0 011.4 0l.934.934a.989.989 0 010 1.4l-8.013 8.012a.989.989 0 01-1.4 0z"
          />
        </svg>
      );
      break;

    case "pensil":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g
                id="Tint"
                opacity="0.499604725"
                transform="translate(20.000000, 28.489875)"
                fill={BRAND_COLOR}
              >
                <polygon points="38.1732019 0 -2.28804213e-12 38.1692019 -2.28804213e-12 47.5132019 9.336 47.5132019 47.5132019 9.34"></polygon>
              </g>
              <path
                d="M78.84,32.1630769 L31,80.0030769 L16,80.0030769 L16,65.0030769 L63.84,17.1630769 C64.56,16.4430769 65.484497,16.0553846 66.4247246,16 L66.8952754,16 C67.6787984,16.0461538 68.4513974,16.3230769 69.1038325,16.8307692 L69.48,17.1630769 L78.84,26.5230769 C80.28,27.9630769 80.3907692,30.2210651 79.1723077,31.7869094 L78.84,32.1630769 Z M58.1732019,28.489875 L20,66.6590769 L20,76.0030769 L29.336,76.0030769 L67.5132019,37.829875 L58.1732019,28.489875 Z M66.66,20.0030769 L61.0016291,25.6614478 L70.3416291,35.0014478 L76,29.3430769 L66.66,20.0030769 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "star":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g
                id="Tint"
                opacity="0.499976749"
                transform="translate(23.268000, 24.811526)"
                fill={BRAND_COLOR}
              >
                <polygon points="32.3108622 15.6245911 24.732 0.24 17.1531378 15.6245911 0.176 18.076 12.4691434 30.0404436 9.556 46.936 24.732 38.9499305 39.904 46.936 36.9948566 30.0404436 49.284 18.076"></polygon>
              </g>
              <path
                d="M58.232,36.775526 L48,16 L37.764,36.775526 L14.8338183,40.0893061 L31.436,56.247526 L27.5028245,79.0677214 L47.996,68.279526 L68.4912816,79.0677214 L64.56,56.247526 L81.1602879,40.0893061 L58.232,36.775526 Z M48,25.051526 L55.5788622,40.4361171 L72.552,42.887526 L60.2628566,54.8519696 L63.172,71.747526 L48,63.7614564 L32.824,71.747526 L35.7371434,54.8519696 L23.444,42.887526 L40.4211378,40.4361171 L48,25.051526 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "responsive":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g
                id="Tint"
                opacity="0.5"
                transform="translate(20.000000, 19.828000)"
                fill={BRAND_COLOR}
              >
                <path d="M52,0.172 C54.209139,0.172 56,1.962861 56,4.172 L56,52.172 C56,54.381139 54.209139,56.172 52,56.172 L4,56.172 C1.790861,56.172 8.86046791e-12,54.381139 8.86046791e-12,52.172 L8.86046791e-12,28.172 C8.86046791e-12,30.381139 1.790861,32.172 4,32.172 L4,32.172 L4,40.172 L40,40.172 L40,4.172 L32,4.172 C32,1.962861 30.209139,0.172 28,0.172 L28,0.172 L52,0.172 Z M52,4.172 L44,4.172 L44,44.172 L4,44.172 L4,52.172 L52,52.172 L52,4.172 Z M28,4.172 L28,28.172 L4,28.172 L4,4.172 L28,4.172 Z"></path>
              </g>
              <path
                d="M48,20 C50.209139,20 52,21.790861 52,24 L52,48 C52,50.209139 50.209139,52 48,52 L24,52 C21.790861,52 20,50.209139 20,48 L20,24 C20,21.790861 21.790861,20 24,20 L48,20 Z M48,24 L24,24 L24,48 L48,48 L48,24 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "font":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g id="Tint" opacity="0.5"></g>
              <path
                d="M20.3029209,68 L24.6921213,55.6420572 L42.3341499,55.6420572 L46.7233503,68 L52.2631177,68 L36.2404057,24.363678 L30.7858655,24.363678 L14.7631535,68 L20.3029209,68 Z M40.6722197,50.9545617 L26.3540515,50.9545617 L33.3426812,31.2670805 L33.68359,31.2670805 L40.6722197,50.9545617 Z M64.7994182,68.7670447 C70.5096401,68.7670447 73.4925918,65.6988658 74.5153181,63.568186 L74.7709996,63.568186 L74.7709996,68 L79.7994039,68 L79.7994039,46.4375206 C79.7994039,36.0398032 71.8732751,34.8466225 67.6971428,34.8466225 C62.7539656,34.8466225 57.128971,36.5511664 54.5721553,42.5170698 L59.344878,44.2216136 C60.4528315,41.8352522 63.0735676,39.2784365 67.8675971,39.2784365 C72.4911723,39.2784365 74.7709996,41.7287182 74.7709996,45.9261574 L74.7709996,46.0966118 C74.7709996,48.5255868 72.2994111,48.3125188 66.3335077,49.0795635 C60.2610703,49.867915 53.6346562,51.2102433 53.6346562,58.7102361 C53.6346562,65.1022755 58.5778333,68.7670447 64.7994182,68.7670447 Z M65.566463,64.2500036 C61.560785,64.2500036 58.6630605,62.4602326 58.6630605,58.9659177 C58.6630605,55.1306941 62.1573753,53.9375134 66.0778261,53.4261503 C68.2085059,53.1704687 73.9187277,52.5738783 74.7709996,51.5511521 L74.7709996,56.1534204 C74.7709996,60.2443256 71.5323664,64.2500036 65.566463,64.2500036 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "plus":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g
                id="Tint"
                opacity="0.5"
                transform="translate(24.000000, 24.000000)"
                fill={BRAND_COLOR}
              >
                <path d="M28,0 L28,20 L48,20 L48,28 L28,28 L28,48 L20,48 L20,28 L0,28 L0,20 L20,20 L20,0 L28,0 Z"></path>
              </g>
              <path
                d="M56,20 L56,40 L76,40 L76,56 L56,56 L56,76 L40,76 L40,56 L20,56 L20,40 L40,40 L40,20 L56,20 Z M52,24 L44,24 L44,44 L24,44 L24,52 L44,52 L44,72 L52,72 L52,52 L72,52 L72,44 L52,44 L52,24 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "mobile":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g
                id="Tint"
                opacity="0.5"
                transform="translate(32.000000, 16.000000)"
                fill={BRAND_COLOR}
              >
                <path d="M23.4644105,0.121251724 C23.3164725,0.200369837 23.2003698,0.316472452 23.1212517,0.464410461 C23.0421336,0.61234847 23,0.792012226 23,0.999129794 L23,2.00174041 C23,2.41597555 22.9157328,2.77530306 22.7574966,3.07117908 C22.5992603,3.3670551 22.3670551,3.59926033 22.0711791,3.75749655 C21.7753031,3.91573278 21.4159755,4 21.0017404,4 L10.9982596,4 C10.5840245,4 10.2246969,3.91573278 9.92882092,3.75749655 C9.6329449,3.59926033 9.40073967,3.3670551 9.24250345,3.07117908 C9.08426722,2.77530306 9,2.41597555 9,2.00174041 L9,0.999129794 C9,0.792012226 8.95786639,0.61234847 8.87874828,0.464410461 C8.79963016,0.316472452 8.68352755,0.200369837 8.53558954,0.121251724 C8.4369642,0.0685063151 8.32423853,0.032198463 8.19867828,0.0138538292 L8.048,0 L3.8458278,0 C2.69958942,0 2.17956645,0.102297612 1.74650936,0.296177099 L1.53473144,0.400699056 C1.04584256,0.662159695 0.662159695,1.04584256 0.400699056,1.53473144 C0.176589937,1.95377906 0.0422767358,2.36991764 0.00847519113,3.3223967 L0,3.8458278 L0,60.1541722 C0,61.4914503 0.139238417,61.9763797 0.400699056,62.4652686 C0.662159695,62.9541574 1.04584256,63.3378403 1.53473144,63.5993009 C1.95377906,63.8234101 2.36991764,63.9577233 3.3223967,63.9915248 L3.8458278,64 L28.1541722,64 C29.4914503,64 29.9763797,63.8607616 30.4652686,63.5993009 C30.9541574,63.3378403 31.3378403,62.9541574 31.5993009,62.4652686 C31.8234101,62.0462209 31.9577233,61.6300824 31.9915248,60.6776033 L32,60.1541722 L32,3.8458278 C32,2.50854969 31.8607616,2.02362033 31.5993009,1.53473144 C31.3378403,1.04584256 30.9541574,0.662159695 30.4652686,0.400699056 C30.0462209,0.176589937 29.6300824,0.0422767358 28.6776033,0.00847519113 L28.1541722,0 L24,0 C23.7920122,0 23.6123485,0.0421336107 23.4644105,0.121251724 Z"></path>
              </g>
              <path
                d="M35.0032097,12.0068788 L60.3083444,12 C62.9829006,12 63.9527593,12.2784768 64.9305371,12.8013981 C65.9083149,13.3243194 66.6756806,14.0916851 67.1986019,15.0694629 C67.7215232,16.0472407 68,17.0170994 68,19.6916556 L68,76.3083444 C68,78.9829006 67.7215232,79.9527593 67.1986019,80.9305371 C66.6756806,81.9083149 65.9083149,82.6756806 64.9305371,83.1986019 C63.9527593,83.7215232 62.9829006,84 60.3083444,84 L35.6916556,84 C33.0170994,84 32.0472407,83.7215232 31.0694629,83.1986019 C30.0916851,82.6756806 29.3243194,81.9083149 28.8013981,80.9305371 C28.3260151,80.0416482 28.0526524,79.159304 28.0068788,76.9967903 L28,19.6916556 C28,17.0170994 28.2784768,16.0472407 28.8013981,15.0694629 C29.3243194,14.0916851 30.0916851,13.3243194 31.0694629,12.8013981 C31.9583518,12.3260151 32.840696,12.0526524 35.0032097,12.0068788 Z M55.4644105,16.1212517 C55.3164725,16.2003698 55.2003698,16.3164725 55.1212517,16.4644105 C55.0421336,16.6123485 55,16.7920122 55,16.9991298 L55,18.0017404 C55,18.4159755 54.9157328,18.7753031 54.7574966,19.0711791 C54.5992603,19.3670551 54.3670551,19.5992603 54.0711791,19.7574966 C53.7753031,19.9157328 53.4159755,20 53.0017404,20 L42.9982596,20 C42.5840245,20 42.2246969,19.9157328 41.9288209,19.7574966 C41.6329449,19.5992603 41.4007397,19.3670551 41.2425034,19.0711791 C41.0842672,18.7753031 41,18.4159755 41,18.0017404 L41,16.9991298 C41,16.7920122 40.9578664,16.6123485 40.8787483,16.4644105 C40.7996302,16.3164725 40.6835275,16.2003698 40.5355895,16.1212517 C40.4369642,16.0685063 40.3242385,16.0321985 40.1986783,16.0138538 L40.048,16 L35.8458278,16 C34.6995894,16 34.1795665,16.1022976 33.7465094,16.2961771 L33.5347314,16.4006991 C33.0458426,16.6621597 32.6621597,17.0458426 32.4006991,17.5347314 C32.1765899,17.9537791 32.0422767,18.3699176 32.0084752,19.3223967 L32,19.8458278 L32,76.1541722 C32,77.4914503 32.1392384,77.9763797 32.4006991,78.4652686 C32.6621597,78.9541574 33.0458426,79.3378403 33.5347314,79.5993009 C33.9537791,79.8234101 34.3699176,79.9577233 35.3223967,79.9915248 L35.8458278,80 L60.1541722,80 C61.4914503,80 61.9763797,79.8607616 62.4652686,79.5993009 C62.9541574,79.3378403 63.3378403,78.9541574 63.5993009,78.4652686 C63.8234101,78.0462209 63.9577233,77.6300824 63.9915248,76.6776033 L64,76.1541722 L64,19.8458278 C64,18.5085497 63.8607616,18.0236203 63.5993009,17.5347314 C63.3378403,17.0458426 62.9541574,16.6621597 62.4652686,16.4006991 C62.0462209,16.1765899 61.6300824,16.0422767 60.6776033,16.0084752 L60.1541722,16 L56,16 C55.7920122,16 55.6123485,16.0421336 55.4644105,16.1212517 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "symbol":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g
                id="Tint"
                opacity="0.499976749"
                transform="translate(15.268000, 27.944000)"
                fill={BRAND_COLOR}
              >
                <path d="M24.732,0.056 L12.732,0.056 L12.732,16.056 L4.732,16.056 C2.522861,16.056 0.732,17.846861 0.732,20.056 C0.732,22.265139 2.522861,24.056 4.732,24.056 L12.732,24.056 L12.732,40.056 L24.732,40.056 L24.732,36.056 C24.732,31.637722 28.313722,28.056 32.732,28.056 C37.150278,28.056 40.732,31.637722 40.732,36.056 L40.732,40.056 L52.732,40.056 L52.732,24.056 L60.732,24.056 C62.941139,24.056 64.732,22.265139 64.732,20.056 C64.732,18.0046566 63.1878392,16.3139714 61.1984845,16.0829109 L60.732,16.056 L52.732,16.056 L52.732,0.056 L40.732,0.056 L40.732,4.056 C40.732,8.27344718 37.4684888,11.7286605 33.3290494,12.0340571 L32.732,12.056 C28.5145528,12.056 25.0593395,8.79248884 24.7539429,4.65304938 L24.732,4.056 L24.732,0.056 Z"></path>
              </g>
              <path
                d="M44,24 L44,32 C44,34.209139 45.790861,36 48,36 C50.209139,36 52,34.209139 52,32 L52,24 L68,24 C70.209139,24 72,25.790861 72,28 L72,40 L76,40 C80.418278,40 84,43.581722 84,48 C84,52.418278 80.418278,56 76,56 L72,56 L72,68 C72,70.209139 70.209139,72 68,72 L52,72 L52,64 C52,61.790861 50.209139,60 48,60 C45.9486566,60 44.2579714,61.5441608 44.0269109,63.5335155 L44,64 L44,72 L28,72 C25.790861,72 24,70.209139 24,68 L24,56 L20,56 C15.7825528,56 12.3273395,52.7364888 12.0219429,48.5970494 L12,48 C12,43.7825528 15.2635112,40.3273395 19.4029506,40.0219429 L20,40 L24,40 L24,28 C24,25.790861 25.790861,24 28,24 L44,24 Z M40,28 L28,28 L28,44 L20,44 C17.790861,44 16,45.790861 16,48 C16,50.209139 17.790861,52 20,52 L28,52 L28,68 L40,68 L40,64 C40,59.581722 43.581722,56 48,56 C52.418278,56 56,59.581722 56,64 L56,68 L68,68 L68,52 L76,52 C78.209139,52 80,50.209139 80,48 C80,45.9486566 78.4558392,44.2579714 76.4664845,44.0269109 L76,44 L68,44 L68,28 L56,28 L56,32 C56,36.2174472 52.7364888,39.6726605 48.5970494,39.9780571 L48,40 C43.7825528,40 40.3273395,36.7364888 40.0219429,32.5970494 L40,32 L40,28 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "grid":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g
                id="Tint"
                opacity="0.5"
                transform="translate(20.000000, 25.828000)"
                fill={BRAND_COLOR}
              >
                <path d="M36,28.172 L36,16.172 L20,16.172 L20,28.172 L36,28.172 Z M40,28.172 L56,28.172 L56,32.172 L40,32.172 L40,44.172 L36,44.172 L36,32.172 L20,32.172 L20,44.172 L16,44.172 L16,32.172 L0,32.172 L0,28.172 L16,28.172 L16,16.172 L0,16.172 L0,12.172 L16,12.172 L16,0.172 L20,0.172 L20,12.172 L36,12.172 L36,0.172 L40,0.172 L40,12.172 L56,12.172 L56,16.172 L40,16.172 L40,28.172 Z"></path>
              </g>
              <path
                d="M76,22 C78.209139,22 80,23.790861 80,26 L80,70 C80,72.209139 78.209139,74 76,74 L20,74 C17.790861,74 16,72.209139 16,70 L16,26 C16,23.790861 17.790861,22 20,22 L76,22 Z M76,26 L20,26 L20,70 L76,70 L76,26 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "animation":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon" transform="translate(0.000000, 0.000000)">
              <g
                id="Tint"
                opacity="0.25"
                transform="translate(12.000000, 31.828000)"
                fill={BRAND_COLOR}
              >
                <path d="M16,0.172 C20.0257016,0.172 23.7041533,1.65875345 26.5162273,4.11313262 C22.5634048,7.02662914 20,11.7139569 20,17 C20,21.8108544 22.1232456,26.1257983 25.4837727,29.0588674 C22.8309156,31.0155203 19.5505129,32.172 16,32.172 C7.163444,32.172 1.082166e-15,25.008556 0,16.172 C-1.082166e-15,7.335444 7.163444,0.172 16,0.172 Z"></path>
              </g>
              <g
                id="Tint"
                opacity="0.5"
                transform="translate(32.000000, 32.828000)"
                fill={BRAND_COLOR}
              >
                <path d="M16,0 C19.7838938,-6.9509001e-16 23.2610006,1.31351088 26.0002322,3.50944427 C22.342475,6.44087514 20,10.9468804 20,16 C20,21.0531196 22.342475,25.5591249 26.0007611,28.491352 C23.2610006,30.6864891 19.7838938,32 16,32 C7.163444,32 1.082166e-15,24.836556 0,16 C-1.082166e-15,7.163444 7.163444,1.623249e-15 16,0 Z"></path>
              </g>
              <path
                d="M68,32.828 C76.836556,32.828 84,39.991444 84,48.828 C84,57.664556 76.836556,64.828 68,64.828 C59.163444,64.828 52,57.664556 52,48.828 C52,39.991444 59.163444,32.828 68,32.828 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "layers":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g
                id="Tint"
                opacity="0.5"
                transform="translate(16.944000, 20.236136)"
                fill={BRAND_COLOR}
              >
                <path d="M46.58,32 L62.108,39.763864 L31.056,55.2917281 L5.25801624e-13,39.763864 L15.528,32 L29.2671456,38.8694369 C30.2323827,39.3520554 31.3441023,39.4210009 32.3511915,39.0762734 L32.8448544,38.8694369 L46.58,32 Z M31.056,0.236 L62.108,15.759864 L31.056,31.2917281 L2.34123831e-12,15.763864 L31.056,0.236 Z"></path>
              </g>
              <path
                d="M67.9996978,50.000136 L84.4222912,58.2111456 C85.4102482,58.7051241 85.8106969,59.9064702 85.3167184,60.8944272 C85.123191,61.281482 84.809346,61.595327 84.4222912,61.7888544 L49.7888544,79.1055728 C48.6627444,79.6686278 47.3372556,79.6686278 46.2111456,79.1055728 L11.5777088,61.7888544 C10.5897518,61.2948759 10.1893031,60.0935298 10.6832816,59.1055728 C10.876809,58.718518 11.190654,58.404673 11.5777088,58.2111456 L27.9996978,50.000136 L32.4716978,52.236136 L16.944,60 L48,75.527864 L79.052,60 L63.5266978,52.236136 L67.9996978,50.000136 Z M49.7888544,16.8944272 L84.4222912,34.2111456 C85.4102482,34.7051241 85.8106969,35.9064702 85.3167184,36.8944272 C85.123191,37.281482 84.809346,37.595327 84.4222912,37.7888544 L49.7888544,55.1055728 C48.6627444,55.6686278 47.3372556,55.6686278 46.2111456,55.1055728 L11.5777088,37.7888544 C10.5897518,37.2948759 10.1893031,36.0935298 10.6832816,35.1055728 C10.876809,34.718518 11.190654,34.404673 11.5777088,34.2111456 L46.2111456,16.8944272 C47.3372556,16.3313722 48.6627444,16.3313722 49.7888544,16.8944272 Z M48,20.472136 L16.944,36 L48,51.527864 L79.052,35.996 L48,20.472136 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "share":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <g
                id="Tint"
                opacity="0.5"
                transform="translate(20.000000, 28.000000)"
                fill={BRAND_COLOR}
              >
                <path d="M52.556,0 L3.44,0 L28,17.536 L52.556,0 Z M56,2.452 L28,22.4515581 L0,2.456 L0,40 L56,40 L56,2.452 Z"></path>
              </g>
              <path
                d="M76,24 C78.209139,24 80,25.790861 80,28 L80,68 C80,70.209139 78.209139,72 76,72 L20,72 C17.790861,72 16,70.209139 16,68 L16,28 C16,25.790861 17.790861,24 20,24 L76,24 Z M76,30.452 L48,50.4515581 L20,30.456 L20,68 L76,68 L76,30.452 Z M72.556,28 L23.44,28 L48,45.536 L72.556,28 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "search":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <path
                d="M59.130463,53.12682 C62.1990537,48.8546767 64,43.6257477 64,38 C64,23.64 52.36,12 38,12 C23.64,12 12,23.64 12,38 C12,52.36 23.64,64 38,64 C43.6286159,64 48.8600083,62.1972169 53.1333535,59.1257686 C53.1333535,59.1257686 60.755569,66.7371791 76,81.96 L81.96,76 C66.7403086,60.7512133 59.130463,53.12682 59.130463,53.12682 Z M38,56 C28.04,56 20,47.96 20,38 C20,28.04 28.04,20 38,20 C47.96,20 56,28.04 56,38 C56,47.96 47.96,56 38,56 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "user":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="icon">
              <path
                d="M48,48 C56.84,48 64,40.84 64,32 C64,23.16 56.84,16 48,16 C39.16,16 32,23.16 32,32 C32,40.84 39.16,48 48,48 Z M48,56 C37.32,56 16,61.36 16,72 L16,80 L80,80 L80,72 C80,61.36 58.68,56 48,56 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;

    case "embed":
      icon = (
        <svg {...svgProps} viewBox="0 0 96 96">
          <g
            id="Icons"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="icon">
              <path
                d="M76,22 C78.209139,22 80,23.790861 80,26 L80,70 C80,72.209139 78.209139,74 76,74 L20,74 C17.790861,74 16,72.209139 16,70 L16,26 C16,23.790861 17.790861,22 20,22 L76,22 Z M76,26 L20,26 L20,70 L76,70 L76,26 Z M53.8684271,37.8578644 L64.0105627,48 L53.8684271,58.1421356 L51.04,55.3137085 L58.3565369,47.9971716 L51.04,40.6862915 L53.8684271,37.8578644 Z M42.1421356,37.8578644 L44.9705627,40.6862915 L37.6540258,47.9971716 L44.9705627,55.3137085 L42.1421356,58.1421356 L32,48 L42.1421356,37.8578644 Z"
                id="Color"
                fill={BRAND_COLOR}
              ></path>
            </g>
          </g>
        </svg>
      );
      break;
    case "404":
      icon = (
        <svg
          width="881px"
          height="357px"
          viewBox="0 0 881 357"
          className={className}
        >
          <defs>
            <linearGradient
              x1="100%"
              y1="50%"
              x2="14.3378764%"
              y2="50%"
              id="linearGradient-1"
            >
              <stop
                stopColor={BRAND_COLOR}
                stopOpacity="0.346513228"
                offset="0%"
              ></stop>
              <stop stopColor={BRAND_COLOR} stopOpacity="0" offset="100%"></stop>
            </linearGradient>
            <linearGradient
              x1="100%"
              y1="50%"
              x2="64.6706633%"
              y2="50%"
              id="linearGradient-2"
            >
              <stop
                stopColor={BRAND_COLOR}
                stopOpacity="0.339422906"
                offset="0%"
              ></stop>
              <stop stopColor={BRAND_COLOR} stopOpacity="0" offset="100%"></stop>
            </linearGradient>
          </defs>
          <g
            id="Website"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="404-copy" transform="translate(-176.000000, -173.000000)">
              <g id="Group" transform="translate(176.000000, 173.000000)">
                <text
                  id="404"
                  fill={BRAND_COLOR}
                  fillRule="nonzero"
                  fontFamily="Inter-SemiBold, Inter"
                  fontStyle="initial"
                  fontSize="340"
                  fontWeight="500"
                  line-spacing="300"
                  letterSpacing="-2.9125"
                >
                  <tspan x="207" y="312">
                    404
                  </tspan>
                </text>
                <path
                  d="M546.747475,98 C531.3367,98 349.087542,65.3333333 0,0 L0,357 L544.737374,279 C579.579125,279 597,248.666667 597,188 C597,100 557.165679,98 546.747475,98 Z"
                  id="Path-2"
                  fill="url(#linearGradient-1)"
                ></path>
                <path
                  d="M546.747475,98 C539.925675,98 500.411607,91.5989106 428.205272,78.7967319 C367.597775,68.0510266 367.282081,140.392663 427.258188,295.821641 L544.737374,279 C579.579125,279 597,248.666667 597,188 C597,100 557.165679,98 546.747475,98 Z"
                  id="Path-2"
                  fill="url(#linearGradient-2)"
                ></path>
                <path
                  d="M479.399865,89.2780703 C512.44539,94.9027384 532.949535,98.0867728 540.912298,98.8301737 C527.380381,100.040363 516.539884,107.609232 508.382955,121.534801 C499.448295,136.788116 494.94072,159.144886 494.860227,188.605114 C494.779735,208.325758 496.771922,224.907197 500.83679,238.349432 C504.901657,251.791667 510.676989,261.913589 518.162784,268.715199 C525.64858,275.516809 534.542992,278.917614 544.846023,278.917614 C546.136206,278.917614 547.40381,278.864461 548.648835,278.758156 C543.818248,280.06929 538.600503,280.816278 532.996678,281 L532.996678,281 L479.584574,288.816491 C472.043757,280.288868 465.846579,269.926032 460.99304,257.727983 C453.386506,238.611032 449.583239,215.570076 449.583239,188.605114 C449.663731,161.640152 453.507244,138.679687 461.113778,119.723722 C465.794722,108.058512 471.725442,98.0926924 478.905938,89.8262633 Z"
                  id="Combined-Shape"
                  fill="#1DCEA2"
                  fillRule="nonzero"
                ></path>
                <path
                  d="M349.88738,64.7295107 C362.244254,66.9712719 374.022537,69.099746 385.222229,71.1149328 L385.21,229.295 L416.84375,229.294034 L416.84375,266.119318 L385.21,266.12 L385.210102,301.841273 L342.468102,307.962273 L342.468,266.12 L224.507102,266.119318 L224.507102,230.50142 L329.428977,64.7272727 Z M342.951,115.4375 L341.019886,115.4375 L270.387784,227.362216 L270.387784,229.295 L342.951,229.295 L342.951,115.4375 Z"
                  id="Combined-Shape"
                  fill="#23C29B"
                  fillRule="nonzero"
                ></path>
              </g>
            </g>
          </g>
        </svg>
      );
      break;

    default:
      break;
  }

  return (
    <i className={`${css.icon} ${className}`} {...iconProps}>
      {icon}
    </i>
  );
};

export default Icon;
